export default "__VITE_ASSET__0l4t9PLb__"